import React, { useLayoutEffect, useRef } from "react";
import styles from "./AnimatedLogo.module.scss";
import variables from "../../styles/scss/_variables.scss";
import { markTextShapes, useAnimatedSvg } from "./logoSvg";

const images = require.context("../../assets/Logos", true);
const logoSrc = (file) => images(file.replace(/['"]+/g, ""));

// Shows the brand logo/icon from _variables.scss on every collapse/expand: the icon draws
// itself in, the logo's text fades in slowly.
// `loop` keeps it drawing in and out (loading indicator).
// `size` is "small" (sidebar), "medium" or "large".
export const AnimatedLogo = ({ collapsed, loop = false, size = "small" }) => {
    const src = logoSrc(collapsed ? variables.collapsedLogo : variables.logo);
    const markup = useAnimatedSvg(src, styles.shape);
    const className = collapsed ? styles.icon : styles.full;
    const ref = useRef(null);

    useLayoutEffect(() => {
        if (!collapsed && markup && ref.current) {
            markTextShapes(ref.current, styles.shape, styles.text);
        }
    }, [collapsed, markup]);

    return (
        <div className={`${styles.logo} ${styles[size] ?? styles.small} ${loop ? styles.loop : ""}`}>
            {markup ? (
                <div
                    key={src}
                    ref={ref}
                    className={className}
                    role="img"
                    aria-label="Logo"
                    dangerouslySetInnerHTML={{ __html: markup }}
                />
            ) : (
                <img className={className} src={src} alt="Logo" />
            )}
        </div>
    );
};
